import React, {Component} from 'react';
import $ from 'jquery';
import PageLoader from './loader';
import MainComponent from './MainComponent';

class AuthTokensList extends MainComponent {
    constructor() {
        super();
        let thisComponent = this;

        this.state = {
            redis_data: this.noDataPreloader()
        };

        this.state = {
            'redis_load_data': setInterval(function () {
                thisComponent.loadData(global.mainDomainName + '?get_all_auth_tokens&only_json', (component, data) => {
                    // console.log(data);

                    if (typeof data === 'string') {
                        return;
                    }

                    // if (!isJson(data)) {
                    if (data || typeof data === 'object') {
                        thisComponent.setState({
                            redis_data: data
                        });
                    }
                });
            }, 1000)
        };
    }

    componentWillUnmount() {
        let thisComponent = this;
        let interval_key = thisComponent.get('redis_load_data');
        clearInterval(interval_key);
    }

    generateTableRows() {
        {
            // let data = JSON.parse(this.state.redis_data);

            // console.log(data);

            return Object.entries(this.state.redis_data).map((value, i) => {
                let k = value[0];
                let v = value[1];

                let expires_in = parseFloat(v['ttl_seconds'] - (new Date().getTime() - new Date(v['date_created']).getTime()) / 1000).toFixed(2);

                return (
                    <tr key={k}>
                        <td>{k}</td>
                        <td>{v['date_created']}</td>
                        <td>{v['ttl_seconds']}</td>
                        <td>{v['user_id']}</td>
                        <td>{expires_in} s</td>
                    </tr>
                );
            });
        }
    }

    noDataPreloader() {
        return (<PageLoader/>);
    }

    render() {
        if (this.state.redis_data == null) return this.noDataPreloader();
        console.log('rendering...');

        return (
            <table className="table">
                <thead>
                <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Date Created</th>
                    <th scope="col">TTL Seconds</th>
                    <th scope="col">User ID</th>
                    <th scope="col">Expires In</th>
                </tr>
                </thead>
                <tbody>
                {this.generateTableRows()}
                </tbody>
            </table>
        );
    }
}

export default AuthTokensList;



// WEBPACK FOOTER //
// ./src/components/AuthTokensList.js